// Feste Liste der Kuendigungsgruende im Kuendigungsdialog; muss zum Server passen
// (services/dieter-server/src/utils/cancellationReasons.ts). Texte in
// locales/*/translation.json unter components.ui.manage_subscription.confirm.reasons.
export const CANCELLATION_REASONS = [
  'too_expensive',
  'one_time_need',
  'business_closed',
  'switched_provider',
  'missing_feature',
  'support_quality',
  'no_answer',
] as const;

export type CancellationReason = (typeof CANCELLATION_REASONS)[number];

export const CANCELLATION_NOTE_MAX = 500;
